var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWorkspace = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.366.717c.275 0 .546.063.792.182l.105.055.021.013 4.2 2.6.05.034c.22.166.447.428.603.744q.02.026.04.054.069.122.085.253.07.23.071.482v4.333c0 .324-.121.642-.268.89-.149.252-.37.511-.656.682l-.007.004-6.867 4-.006.004a1.82 1.82 0 0 1-1.813-.013l-4.2-2.6-.05-.034a2.1 2.1 0 0 1-.552-.664c-.128-.235-.248-.548-.248-.869v-4.4q0-.245.073-.482a.7.7 0 0 1 .095-.27q.02-.03.042-.056c.169-.312.43-.572.748-.718L8.464.958 8.47.954c.274-.155.582-.237.896-.237M2 10.867a.3.3 0 0 0 .016.07 1 1 0 0 0 .069.16.9.9 0 0 0 .173.228L6 13.641V9.703L2 7.222zm5.334-1.15v3.9l1.332-.777V8.944zM10 8.17v3.892l1.333-.777V7.397zm2.667-1.547v3.886l1.063-.62a.7.7 0 0 0 .187-.212.8.8 0 0 0 .068-.147c.013-.04.015-.062.015-.064V5.852zm-3.3-4.573a.5.5 0 0 0-.238.062h-.001l-6.62 3.856 4.17 2.587 6.885-3.993L9.599 2.11a.5.5 0 0 0-.233-.06"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWorkspace);
export default ForwardRef;